import { RiskFactorInfo } from '../../models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../models/select-plan/select-plan-info';
import { PaymentInfo } from '../../models/payment/payment-info';
import { PolicyContractInfo } from '../../models/policy-contract/policy-contract-info';

/**
 * リクエスト
 */
export class SettlementContractRequest {
	public transactionDate:		string				= null; // トランザクション日時
	public riskFactorInfo:		RiskFactorInfo		= null; // リスクファクタ情報
	public selectPlanInfo:		SelectPlanInfo		= null; // 選択プラン情報
	public policyContractInfo:	PolicyContractInfo	= null; // 
	public paymentInfo:			PaymentInfo			= null; //
	public inquiryPassword:		string				= null; // 
	public paypayOrderId: 		string				= null;
	public bookingNo: 			string				= null;
	public paypayCustTxn:		string				= null;
	public authMailId:			string				= null;
	public paypayMStatus:		string				= null;
	public paypayVResCode:		string				= null;
}